import { useState, useEffect, useCallback } from 'react';

export const usePWA = () => {
  const [isPWA, setIsPWA] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Detect if running as PWA
    const checkPWA = () => {
      try {
        // Check if running in standalone mode (PWA)
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        
        // Check if running in fullscreen mode (PWA)
        const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
        
        // Check if running in minimal-ui mode (PWA)
        const isMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
        
        // Check if launched from home screen (iOS)
        const isIOSStandalone = window.navigator?.standalone === true;
        
        // Check if running in PWA mode
        const isPWAMode = isStandalone || isFullscreen || isMinimalUI || isIOSStandalone;
        
        setIsPWA(isPWAMode);
      } catch (error) {
        setIsPWA(false);
      }
    };

    // Detect if mobile device
    const checkMobile = () => {
      try {
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobileDevice = mobileRegex.test(navigator.userAgent);
        setIsMobile(isMobileDevice);
      } catch (error) {
        setIsMobile(false);
      }
    };

    // Initial checks
    checkPWA();
    checkMobile();
    setIsLoading(false);

    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleChange = () => {
      checkPWA();
    };

    // Listen for orientation changes (can indicate PWA installation)
    const handleOrientationChange = () => {
      checkPWA();
    };

    // Add event listeners
    mediaQuery.addEventListener('change', handleChange);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
    }, []);

  return { 
    isPWA, 
    isMobile, 
    isMobilePWA: isPWA && isMobile,
    isLoading 
  };
};
